// extracted by mini-css-extract-plugin
module.exports = {"loader-body":"styles_loader-body__3Y6qv"};